import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../styles/about.css";

const BUCKET_URL = "https://storage.googleapis.com/architecture-studio-about/";
const url = `${BUCKET_URL}index.json?nocache=${Date.now()}`;

export default function About() {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const sorted = data.sort((a, b) => a.priority - b.priority);
        setTeam(sorted);
      })
      .catch((err) => console.error("Error loading team data:", err));
  }, []);

  const founders = team.filter((m) => m.priority === 1);
  const others = team.filter((m) => m.priority !== 1);

  const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 0.8, ease: "easeOut" } },
  };

  return (
    <div className="about-container">
      {/* Card 1 */}
      <motion.section
  className="about-card first-card"
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true, amount: 0.3 }}
  variants={cardVariants}
>
  <div className="about-content">
    <h1>About Our Studio</h1>
    <p>
      AVA Architects is an international
award-winning architecture,
engineering, and consultancy firm
based in Erbil, Iraq. Founded in
2012, the firm has built a reputation
for delivering innovative, contextsensitive, and sustainable design
solutions across a wide range of
project types.
Combining local insight with global
design standards, AVA Architects
offers comprehensive services in
architecture, structural and MEP
engineering, urban planning, interior
design, and project management.
The firm’s multidisciplinary team is
committed to creating spaces that
are functional, aesthetically refined,
and environmentally responsible.
Over the years, AVA Architects has
led the design and execution of
numerous high-profile projects
across the residential, commercial,
institutional, and public sectors.
Its design excellence has been
recognized through multiple
architectural awards and
successful competition entries.
Driven by a passion for design,
technical precision, and client
satisfaction, AVA Architects continues
to shape the built environment
across Iraq and beyond.
    </p>
  </div>
</motion.section>

      {/* Card 2 */}
      <motion.section
        className="about-card"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={cardVariants}
      >
        <div className="about-content second-card">
          <h1>Our Vision</h1>
          <p>
            “Global standards, local vision.”
We design innovative, sustainable,
and context-sensitive spaces that
shape communities and enrich lives.
          </p>
        </div>
      </motion.section>

      {/* Card 3 – Team Section */}
      <section className="about-card team-section">
        <div className="about-content">
          <h1>Our Team</h1>

          {/* Founders */}
          {founders.length > 0 && (
            <div className="team-grid founders">
              {founders.map((m) => (
                <motion.div
                  className="team-card"
                  key={m.filename}
                  initial={{ y: 50, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                >
                  <img src={`${BUCKET_URL}${m.filename}`} alt={m.name} />
                  <h3>{m.name}</h3>
                  <p>{m.title}</p>
                </motion.div>
              ))}
            </div>
          )}

          {/* Others */}
          {others.length > 0 && (
            <div className="team-grid others">
              {others.map((m) => (
                <motion.div
                  className="team-card"
                  key={m.filename}
                  initial={{ y: 50, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  viewport={{ once: true, amount: 0.2 }}
                  transition={{ duration: 0.8, ease: "easeOut" }}
                >
                  <img src={`${BUCKET_URL}${m.filename}`} alt={m.name} />
                  <h3>{m.name}</h3>
                  <p>{m.title}</p>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
